import { gql } from '@apollo/client';

export const TOGGLE_AUTHOR_MUTE = gql`
    mutation toggleAuthorMute($authorId: String!) {
        toggleAuthorMute(authorId: $authorId)
    }
`;
